module.exports = __webpack_public_path__ + "static/media/29BDOS16.0eeda1be.jpg";